/**
 * 三层 Analytics 一次加载 ——「3 层一个不少」是核心需求
 *   - Cloudflare Web Analytics（实时层）
 *   - Google Analytics 4（深度层）
 *   - PostHog（行为层，有 key 才加载）
 */
import { useEffect } from 'react';
import { getEnv } from '@/lib/env';

export default function Analytics() {
  useEffect(() => {
    const env = getEnv();

    // Cloudflare Web Analytics
    if (env.VITE_CF_ANALYTICS_TOKEN) {
      const s = document.createElement('script');
      s.defer = true;
      s.src = 'https://static.cloudflareinsights.com/beacon.min.js';
      s.setAttribute('data-cf-beacon', JSON.stringify({ token: env.VITE_CF_ANALYTICS_TOKEN }));
      document.head.appendChild(s);
    }

    // GA4
    if (env.VITE_GA4_ID) {
      const s1 = document.createElement('script');
      s1.async = true;
      s1.src = `https://www.googletagmanager.com/gtag/js?id=${env.VITE_GA4_ID}`;
      document.head.appendChild(s1);

      const s2 = document.createElement('script');
      s2.text = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', '${env.VITE_GA4_ID}');
      `;
      document.head.appendChild(s2);
    }

    // PostHog（异步、按需加载）
    if (env.VITE_POSTHOG_KEY) {
      void import('posthog-js').then(({ default: posthog }) => {
        posthog.init(env.VITE_POSTHOG_KEY, {
          api_host: env.VITE_POSTHOG_HOST,
          capture_pageview: true,
          capture_pageleave: true,
        });
        window.posthog = posthog;
      });
    }
  }, []);

  return null;
}
